import { useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import Form from "rc-field-form";
import Field from "../../../../../components/Field";
import Button from "../../../../../components/Button";
import LanguageSelect from "../../../../../components/Inputs/LanguageSelect";
import { usePreferences } from "../../../../Settings/Configuration/hooks/usePreferences";
import { usePreferenceMutation } from "../../../../Settings/Configuration/api/usePreferenceMutation";

function ChangeLanguage({ close }) {
	const { t } = useTranslation();
	const [form] = Form.useForm();
	const profileSettings = usePreferences("profileSettings");
	const { mutateAsync: submit, isPending: submitting } = usePreferenceMutation("user", "profileSettings");

	const onFinish = useCallback(async (values) => {
		try {
			await submit({
				...profileSettings,
				language: values?.language,
			});
			close();
		} catch (error) {
			// error toast handled by usePreferenceMutation
		}
	}, [profileSettings, submit, close]);

	useEffect(() => {
		form.setFieldsValue({
			language: profileSettings?.language
		})
	}, [form, profileSettings?.language]);

	return (
		<Form
			layout="vertical"
			form={form}
			onFinish={onFinish}
		>
			<Field 
				name="language"
				label={t("language")}
				rules={[
					{
						required: true,
						message: t("required-language")
					}
				]}
			>
				<LanguageSelect placeholder={t("language")} />
			</Field>

			<div className="d-flex justify-content-end">
				<Button
					className="btn-round btn-icon shadow-none border btn btn-secondary btn-sm"
					onClick={close}
					disabled={submitting}
				>
					{t("cancel")}
				</Button>

				<Button
					color="primary"
					type="submit"
					loading={submitting}
					className="btn-round btn-icon shadow-none border px-3 btn btn-dark btn-sm"
				>
					{t("save")}
				</Button>
			</div>
		</Form>
	)
}

export default ChangeLanguage;
